<template>
    <button>
        <slot></slot>
    </button>
</template>

<style scoped>
button {
    background-color: #000;
    color: #fff;
    padding: 12px 24px;
    font-weight: 500;
    transition: 0.3s ease;
}

button:hover,
button:active{
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.44) 0%, rgba(255, 255, 255, 0.44) 100%), #000;
}

</style>